import { ModalFullscreen } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackMapOpenClick } from './tracking';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { closeMap, removeActivePin } from '../../actions/map';
import { LoadableErrorBoundary } from '../../components/LoadableErrorBoundary';
import { usePopstateEventQuery } from '../../hooks/browserHistory';
import { selectIsMapOpen, selectMapData } from '../../selectors';
import { useApplicationContext } from '../../utils/applicationContext';
import { MapLoadable } from '../MapContainer';

export const MapModalContainer = () => {
  const dispatch = useDispatch();
  const [isOpenModal, setOpenModal] = React.useState(false);

  const isMapOpen = useSelector(selectIsMapOpen);
  const { offerPins } = useSelector(selectMapData);

  const handleCloseMap = () => {
    dispatch(closeMap());
    dispatch(removeActivePin());
    dispatch(fetchFavoriteEntities());
    setOpenModal(false);
  };

  const { logger } = useApplicationContext();
  const handleRetry = () => MapLoadable.load();

  React.useEffect(() => {
    if (isMapOpen && offerPins.length) {
      setOpenModal(true);
      trackMapOpenClick(offerPins);
    }
  }, [isMapOpen, offerPins]);

  usePopstateEventQuery(() => {
    handleCloseMap();
  });

  return (
    <ModalFullscreen zIndex={10} onClose={handleCloseMap} open={isOpenModal} theme="white">
      <LoadableErrorBoundary logger={logger} onRetry={handleRetry}>
        <MapLoadable onClose={handleCloseMap} />
      </LoadableErrorBoundary>
    </ModalFullscreen>
  );
};
